import React from "react";

export function AvailableLoanOptionsIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60.43 64.72"
      width="30"
      height="30"
      {...props}
    >
      <g id="icons">
        <g id="available_loan_options" data-name="available loan options">
          <path
            className="cls-1"
            d="m43,64.72H0V8.41h33.79l9.21,9.85v46.46Zm-40-3h37V19.45l-7.51-8.04H3v50.31Z"
          />
          <path
            className="cls-1"
            d="m53.19,53.33H15.3V3.5h29.82l8.07,8.63v41.2Zm-35.89-2h33.89V12.92l-6.94-7.42h-26.95v45.83Z"
          />
          <path
            className="cls-1"
            d="m60.43,38.21h-28.93V0h22.81l6.12,6.55v31.67Zm-27.93-1h26.93V6.94l-5.55-5.94h-21.37v36.21Z"
          />
        </g>
      </g>
    </svg>
  );
}
